import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Label } from '@models/admin-users';
import { ToastService } from '@services/toastService/toastMessage.service';

/**
 * Add Editorial and Legal labels
 *
 */

@Component({
    selector: 'app-add-topics',
    templateUrl: './add-topics.component.html',
    styleUrls: ['./add-topics.component.scss']
    // see styles/ng-zorro/nz-modal.scss for global styles
    ,
    standalone: false
})
export class AddTopicsComponent implements OnInit, OnChanges {

  @Input() addLabelsVisible;

  @Input() isNewLabel;

  existingCode: any;

  editFormResetBackup: any;

  rteData: any;

  isVisible: boolean;

  isEmitted: boolean;

  rtEditData: any;

  newTopicLabel: { topicCode: any; topicName: any; notes: string[]; deleted: boolean; };

  topicId: any;

  sampleFormResetBackup: any;

  @Input() set editLabels(value) {

    this.editForm = this.fb.group({
      topicCode: this.fb.control<string | null>(value.topicCode, Validators.required),
      notes: this.fb.control<string | null>(value.notes),
      topicName: this.fb.control<string | null>(value.topicName, Validators.required),
      topicActiveState: this.fb.control<boolean | null>(!value.deleted)
    });

    this.editFormResetBackup = this.fb.group({
      topicCode: this.fb.control<string | null>(value.topicCode, Validators.required),
      notes: this.fb.control<string | null>(value.notes),
      topicName: this.fb.control<string | null>(value.topicName, Validators.required),
      topicActiveState: this.fb.control<boolean | null>(!value.deleted)
    });
    this.existingCode = value.topicCode;
    this.rtEditData = value.notes;
    this.topicId = value.topicId;

  }

  @Input() typeOfLabel;

  @Output() closeLabels: EventEmitter<any> = new EventEmitter<any>();

  @Output() updatedLabels: EventEmitter<any> = new EventEmitter<any>();

  @Output() emitNewLabel: EventEmitter<any> = new EventEmitter<any>();

  @Output() addedLabelType: EventEmitter<any> = new EventEmitter<any>();

  newMarkAsLabel = [];

  newStatusLabel = [];

  labelObj = {} as Label;

  selectedValue = 'markAs';

  labelName = '';

  topicCode = '';

  topicName = '';

  topicDescription = '';

  labelType = 'Mark As';

  topicLabel: { topicName: string; topicId: string; notes: string; deleted: boolean };

  sampleForm: any;

  editForm: any;

  constructor(
    private toastService: ToastService,
    private fb: FormBuilder
  ) { }

  ngOnChanges(changes: SimpleChanges) {

    console.log(changes);
    this.sampleForm = this.fb.group({
      topicCode: this.fb.control<string | null>(null, Validators.required),
      notes: this.fb.control<string | null>(null),
      topicName: this.fb.control<string | null>(null, Validators.required),
      topicActiveState: this.fb.control<boolean | null>(true)
    });

    this.sampleFormResetBackup = this.fb.group({
      topicCode: this.fb.control<string | null>(null, Validators.required),
      notes: this.fb.control<string | null>(null),
      topicName: this.fb.control<string | null>(null, Validators.required),
      topicActiveState: this.fb.control<boolean | null>(true)
    });

    Object.keys(this.sampleForm.controls).forEach(key => {
      if (this.sampleForm.controls[key].invalid) {
        this.sampleForm.controls[key].value = '';
      }
    });
  }

  ngOnInit() {

    this.labelObj.value = '';
    this.labelObj.label = '';
    this.labelObj.inActive = false;

    this.sampleForm = this.fb.group({
      topicCode: this.fb.control<string | null>(null, Validators.required),
      notes: this.fb.control<string | null>(null),
      topicName: this.fb.control<string | null>(null, Validators.required),
      topicActiveState: this.fb.control<boolean | null>(true)
    });

    this.sampleFormResetBackup = this.fb.group({
      topicCode: this.fb.control<string | null>(null, Validators.required),
      notes: this.fb.control<string | null>(null),
      topicName: this.fb.control<string | null>(null, Validators.required),
      topicActiveState: this.fb.control<boolean | null>(true)
    });

  }

  // Code improvised made for edit pop up, includes NRT-14736 also
  handleOk() {
    if (this.editForm.valid) {
      console.log('submit', this.editForm.value);
      this.updateLabel();
    } else {
      Object.keys(this.editForm.controls).forEach(key => {
        if (this.editForm.controls[key].invalid) {
          this.editForm.controls[key].markAsDirty();
        }
        this.editForm.controls[key].updateValueAndValidity({ onlySelf: true });
      });
      this.rteData = '';
      this.rtEditData = '';
    }

  }

  updateLabel() {

    if (this.editForm.controls.topicCode.value !== '' && this.editForm.controls.topicName.value !== '') {
      this.editForm.controls.notes.value = this.rteData;
      this.topicLabel = {
        topicName: this.editForm.controls.topicName.value,
        notes: this.editForm.controls.notes.value ? this.editForm.controls.notes.value : '',
        deleted: !this.editForm.controls.topicActiveState.value,
        topicId: this.topicId
      };
      this.closeLabels.emit(true);
      this.editForm.topicCode = '';
      this.editForm.topicName = '';
      this.editForm.notes = '';
      this.rteData = '';
      this.rtEditData = '';
      this.updatedLabels.emit(this.topicLabel);

    } else {

      this.toastService.createMessage('warning', 'Topic details cannot be Empty');

    }

  }

  submitForm(): void {
    if (this.sampleForm.valid) {
      console.log('submit', this.sampleForm.value);
      this.addLabel();
    } else {
      Object.keys(this.sampleForm.controls).forEach(key => {
        if (this.sampleForm.controls[key].invalid) {
          this.sampleForm.controls[key].markAsDirty();
        }
        this.sampleForm.controls[key].updateValueAndValidity({ onlySelf: true });
      });
      this.rteData = '';
      this.rtEditData = '';
    }
  }

  addLabel() {

    if (this.sampleForm.controls.topicCode.value !== '' && this.sampleForm.controls.topicName.value !== '') {
      this.sampleForm.controls.notes.value = this.rteData;
      this.newTopicLabel = {
        topicCode: this.sampleForm.controls.topicCode.value,
        topicName: this.sampleForm.controls.topicName.value,
        notes: this.sampleForm.controls.notes.value ? this.sampleForm.controls.notes.value : '',
        deleted: !this.sampleForm.controls.topicActiveState.value
      };
      this.emitNewLabel.emit(this.newTopicLabel);
      this.closeLabels.emit(true);
      this.sampleForm = this.sampleFormResetBackup;
      this.rteData = '';
      this.rtEditData = '';
    } else {

      this.toastService.createMessage('warning', 'Topic details cannot be Empty');

    }

  }

  handleCancel() {

    this.labelObj.label = '';
    this.labelObj.value = '';
    this.labelName = '';
    this.selectedValue = 'markAs';
    this.closeLabels.emit(true);
    Object.keys(this.sampleForm.controls).forEach(key => {
      if (this.sampleForm.controls[key].invalid) {
        this.sampleForm.controls[key].value = '';
      }
    });
    this.sampleForm = this.sampleFormResetBackup;
    this.rteData = '';
    this.rtEditData = '';
    this.editForm = this.editFormResetBackup;

  }

  changeLabelName(value) {

    console.log('Label Name', value);
    this.labelObj.label = value.toUpperCase();
    this.labelObj.value = value.toUpperCase();
    this.labelObj.inActive = false;

  }

  changedType(value) {

    console.log('Changed Value', value);
    if (value === 'status') {

      this.labelType = 'Status';

    } else if (value === 'markAs') {

      this.labelType = 'Mark As';

    }

  }

  getRTEData(data) {
    this.rteData = data
    this.sampleForm.controls.notes.value = this.rteData;
  }

  updateRTEData(event) {
    if (event)
      this.rteData = event;
  }

  changeLabelStatus(val, item) {

    console.log('Value changes', val, item);
    if (val === false) {

      item.inActive = true;

    } else if (val === true) {

      item.inActive = false;

    }

  }

}
